import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Avatar } from '@mui/material';
import { View } from 'components/ChatbotWidget/constants/view';
import { ChatbotWidgetContext } from 'components/ChatbotWidget/utils/ChatbotWidgetContext';
import { Typography, Skeleton } from 'gd-design-library';
import { Button } from 'components/baseComponents/Button';
import styles from './ChatHeader.module.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);
const CN = 'chat-header';
const leftClass = `${CN}__left`;

export const ChatHeader = (): React.ReactElement => {
  const { setView, client, options } = useContext(ChatbotWidgetContext);

  const [ title, setTitle ] = useState<string | null>(null);
  const [ isFinishingChat, setIsFinishingChat ] = useState(false);

  useEffect(() => {
    if (!client) return;

    client.getCompany().then(company => {
      setTitle(company.name);
    });
  }, [ client ]);

  const finishChat = useCallback(async () => {
    if (!client) return;

    setIsFinishingChat(true);
    await client.finishChat();
    setView(View.RATING);
    setIsFinishingChat(false);
  }, [ client, setView ]);

  return (
    <div className={ cx(CN) }>
      <div className={ cx(leftClass) }>
        <Avatar src={ options.logoUrl } />
        {title
          ? <Typography variant='h6'>{title}</Typography>
          : <Skeleton width='120px' height='40px' />
        }
      </div>
      <Button
        variant='outlined'
        onClick={ finishChat }
        loading={ isFinishingChat }
      >
        Finish Chat
      </Button>
    </div>
  );
};
